"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _options = require("../options/options");
var _roster = _interopRequireDefault(require("../../services/roster"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  Option
} = _antd.Select;
class GroupSelect extends _react.default.Component {
  state = {
    loading: false,
    groups: []
  };
  componentDidMount() {
    this.loadGroups();
  }
  render() {
    const {
      ...props
    } = this.props;
    const {
      loading,
      groups
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_antd.Select, _extends({
      loading: loading,
      showSearch: true,
      optionFilterProp: "children",
      filterOption: _options.filterOptions
    }, props), groups.map(group => /*#__PURE__*/_react.default.createElement(Option, {
      key: group.id,
      value: group.id
    }, group.name)));
  }
  loadGroups = async () => {
    const {
      auth
    } = this.props;
    this.setState({
      loading: true
    });
    try {
      const rosterService = new _roster.default(auth.state);
      const groups = await rosterService.listGroups();
      this.setState({
        groups,
        loading: false
      });
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false
      });
    }
  };
}
exports.default = GroupSelect;
//# sourceMappingURL=group-select.js.map